export const FIND_SPOT_REQUEST = 'FIND_SPOT_REQUEST';

export const findSpotRequest = ( id: string ) => ({
    type: FIND_SPOT_REQUEST,
    payload: { id }
});
